import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";

export const Route = createFileRoute("/funzionalita/analisi-documenti")({
  head: () => seoMeta({
    title: "Analisi documenti legali con AI",
    description: "Carica PDF di contratti, atti o sentenze: ottieni sintesi, parti, scadenze, clausole critiche e analisi dei rischi in pochi secondi.",
    path: "/funzionalita/analisi-documenti",
  }),
  component: () => (
    <ContentPage
      eyebrow="Funzionalità"
      title="Analisi documenti legali con AI"
      lead="LexAIPro analizza contratti, atti, sentenze e perizie in formato PDF o Word producendo sintesi, estrazione clausole, parti, date chiave e segnalazione dei rischi."
      tldr="Upload PDF → sintesi 1 pagina, parti, date, clausole estratte e rischi classificati per severità, in meno di 60 secondi."
      breadcrumbs={[{name:"Home",path:"/"},{name:"Funzionalità",path:"/funzionalita/analisi-documenti"},{name:"Analisi documenti",path:"/funzionalita/analisi-documenti"}]}
      sections={[
        { heading: "Cosa estrae l'analisi", bullets: [
          "Sintesi esecutiva di una pagina con i punti chiave",
          "Parti contrattuali (denominazione, ruolo, P.IVA quando presente)",
          "Date critiche (scadenze, recesso, rinnovi)",
          "Clausole standard e atipiche, con citazione del passaggio",
          "Mappa dei rischi (basso, medio, alto) con motivazione",
        ] },
        { heading: "Formati supportati", body: "PDF, DOCX, DOC, TXT, RTF, ODT. Fino a 50 MB per file. Documenti scansionati supportati tramite OCR integrato." },
        { heading: "Privacy", body: "Zero retention: i documenti vengono eliminati dopo l'elaborazione. Nessun addestramento sui tuoi dati. Server in UE." },
      ]}
      faq={[
        { q: "L'analisi sostituisce la lettura?", a: "No. Velocizza la prima lettura e segnala i punti critici. La verifica resta del professionista." },
        { q: "Quanti documenti posso analizzare?", a: "Dipende dal piano. Da 100 a illimitate analisi mensili." },
        { q: "Funziona con scansioni?", a: "Sì, l'OCR è integrato. La qualità dell'estrazione dipende dalla qualità della scansione." },
      ]}
      cta={{ label: "Analizza un documento", to: "/signup" }}
      heroImage={pickContent(41)}
      updated="2026"
    />
  ),
});
